import { useEffect } from "react";

import { useAppUtilityContext } from "../../Contexts/AppUtilityContext";
import BattlecardHeader from "./battlecard-header";

export default function LegacyCheckPageLayout({ children }) {
  const { setAppUtilityProps } = useAppUtilityContext();

  useEffect(() => {
    setAppUtilityProps((p) => ({ ...p, hideNavigationBar: true, lockedRoutes: ["/deals", "/cash"] }));

    return () => setAppUtilityProps((p) => ({ ...p, lockedRoutes: [], hideNavigationBar: false }));
  }, [setAppUtilityProps]);

  return (
    <div className="bc-legacy-check-layout">
      <BattlecardHeader />
      {children}
    </div>
  );
}
